import React from 'react'

const ItemFooter = (props) => {
	return (
		<div>{props.children}</div>
	)
}

export default ItemFooter